import React from "react";
import AboutComponent from "../components/About/AboutComponent";
import { useStateContext } from "../context/ContextProvider";
import CoreValues from "../components/About/CoreValues";

const AboutPage = ({ routes }) => {
  const {
    isMobile
  } = useStateContext();

  return (
    <>
      <div className="w-full relative py-5">
        <div className="h-[50px]"></div>
        <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4">
          <div className="text:6xl md:text-7xl lg:text-8xl uppercase font-bold mt-5 pt-5">
            DO DEAL
          </div>
          <div className="w-fit flex flex-col">
            <div className="text:4xl md:text-5xl lg:text-6xl uppercase font-bold">
              Innovate, Create, Elevate
            </div>
            <div className="flex justify-end w-full my-1 lg:my-5 py-5">
              <div className="w-[250px] text-xs text-[var(--l-gray)]">
                Your strategic partner for cutting-edge solutions and sustainable business growth.
              </div>
            </div>
          </div>
        </div>
        <div className=" relative padding-container w-full my-5 py-5 text-start">
          <AboutComponent />

          <div className="relative md:absolute top-0 left-2/3 flex justify-center"
            style={{
              zIndex: -1
            }}>
            <div className="rotate-45 flex justify-center">
              <div
                className="w-[100px] h-[200px] lg:w-[150px] lg:h-[300px] rounded-e-full"
                style={{
                  backgroundImage:
                    "linear-gradient(to bottom right, var(--secondary), var(--primary)",
                  boxShadow:
                    "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                  zIndex: -1,
                }}
              ></div>
              <div
                className="w-[100px] h-[200px] lg:w-[150px] lg:h-[300px] rounded-e-full"
                style={{
                  backgroundImage:
                    "linear-gradient(to bottom right, var(--secondary), var(--primary)",
                  boxShadow:
                    "inset 6px 6px 4px rgba(255,255,255,0.25), inset -6px -6px 8px rgba(0,0,0,0.2)",
                  zIndex: -1,
                }}
              ></div>
            </div>
          </div>
        </div>
        <CoreValues />
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default AboutPage;
